import ReserveVehicles from '../components/Parameters/ReserveVehicles'

let routes = {
    path: '/parameters',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/parameters/reserveVehicles',
            name: 'Parâmetros de Reserva',
            component: ReserveVehicles
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/parameters.js